import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import { searchBeanMap, searchBeanMapAgencyFilter } from "@wikicasa/common/model/RealEstateSearchBean";
//@ts-ignore
import { CONTRACT } from "@customTypes/ContractEnum";
var parseUrlPath = function parseUrlPath() {
  var urlToParse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  /*
  * The regex will match any string that:
  * - Starts with hyphens (-) or with slashes (/)
  * - Ends with hyphens
  * - Contains haypens at the beginning and at the end of the string
  * */
  return "".concat(urlToParse.replace(/(^\/+)|(^-+|-+$)/g, ""), "/");
};
export function buildURL(cityURL, listingTypology, contractType, zone, seoFilter, agencyAndPlace, district) {
  var URL = "/";
  if (contractType) {
    URL += (contractType == CONTRACT.AUCTION ?
    // @ts-ignore
    window["_auctionLabel"] : contractType == CONTRACT.RENT ? window["_rentLabel"] : window["_saleLabel"]) + "-";
  }
  if (listingTypology) {
    URL += "".concat(listingTypology, "/");
  }
  if (agencyAndPlace) {
    URL += "".concat(agencyAndPlace, "/");
  }
  if (cityURL) {
    URL += parseUrlPath(cityURL);
  }
  if (zone) {
    URL += parseUrlPath(zone);
  }
  if (!zone && district) {
    URL += parseUrlPath(district);
  }
  if (seoFilter) {
    URL += parseUrlPath(seoFilter);
  }
  return URL;
}
export function buildParams(searchBean) {
  var params = Object.keys(searchBeanMap).map(key => {
    if (![false, undefined, null, ""].includes(searchBean[key])) {
      return encodeURIComponent(searchBeanMap[key]) + "=" + encodeURIComponent(searchBean[key]);
    } else return null;
  }).filter(param => param !== null);
  return params.length ? "?".concat(params.join("&")) : "";
}
export function buildParamsForAgency(searchBean) {
  var params = Object.keys(searchBeanMapAgencyFilter).map(key => {
    if (searchBean[key]) {
      if (Array.isArray(searchBean[key])) {
        var arr = searchBean[key];
        var nameField = searchBeanMapAgencyFilter[key];
        var strToReturn = "";
        for (var i = 0; i < arr.length; i++) {
          strToReturn += encodeURIComponent(nameField) + "=" + encodeURIComponent(arr[i]);
          strToReturn += i < arr.length - 1 ? "&" : "";
        }
        return strToReturn;
      } else {
        return encodeURIComponent(searchBeanMapAgencyFilter[key]) + "=" + encodeURIComponent(searchBean[key]);
      }
    } else return null;
  }).filter(param => param !== null);
  return params.length ? "?".concat(params.join("&")) : "";
}